import { computed, Pipe, PipeTransform, Signal, inject } from '@angular/core';
import { BrandingInfos } from '@aston/foundation/models';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';

import { selectTenant } from '../../root-store/app-store/selectors';

@Pipe({
	name: 'branding',
})
export class BrandingPipe implements PipeTransform {
	private fatStore = inject(Store);


	referential = toSignal(this.fatStore.select(selectTenant))

	transform(key: keyof BrandingInfos): Signal<string> {
		return computed(() => (this.referential()?.branding || {})[key]);
	}
}
